// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__21Spw","overflowing":"ReadFullNote_overflowing__37GJ9"};